// Template266: Pekín - Día 1 Wangfujing (Dia1Pagina2Pekin.jsx)
// Cabecera, mapa iframe + botón Ver mapa grande + sticker, intro, bloque Wangfujing (img + SabiasQue + tip), Cómo llegar.

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template266 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const blockTitle = page?.texts?.[2]?.content;
	const blockBody = page?.texts?.[3]?.content;
	const tipText = page?.texts?.[4]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const stickerImage = getImageSrc("sticker");
	const sticker2 = getImageSrc("sticker2");
	const logoImage = getCanvasImageUrl("logo");
	const mapUrl = page?.maps?.[0] || "";

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const comoLlegar = page?.data?.comoLlegar;
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					height: "100%",
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: "#C41E3A",
						flexShrink: 0,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: "#24221a",
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa grande Wangfujing"
					src={mapUrl}
					style={{
						border: 0,
						flex: 1,
						width: "100%",
						height: "100%",
						minHeight: 0,
					}}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Mapa */}
			<Box
				data-block-id="map"
				sx={{
					flex: 1,
					minHeight: isSmallScreen ? 320 : 400,
					marginTop: "-70px",
					position: "relative",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{mapUrl && (
					<>
						<iframe
							title="Mapa Wangfujing"
							src={mapUrl}
							style={{
								border: 0,
								flex: 1,
								width: "100%",
								minHeight: 0,
							}}
							allowFullScreen
							loading="lazy"
						/>
						<button
							onClick={() => setFullscreen(true)}
							style={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: "#C41E3A",
								color: "#fff",
								padding: "8px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								fontFamily: "'Poppins', sans-serif",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</button>
					</>
				)}
				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: 105,
							position: "absolute",
							bottom: -10,
							left: -10,
						}}
					/>
				)}
			</Box>

			{/* Contenido */}
			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1 }}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{img1 && (
							<Box
								component="img"
								src={img1}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue[0] && (
							<Box
								sx={{
									position: "absolute",
									top: isSmallScreen ? 120 : 80,
									left: isSmallScreen ? "60%" : "60%",
								}}
							>
								<SabiasQue
									icono={sabiasQue[0].icono}
									texto={sabiasQue[0].texto}
								/>
							</Box>
						)}
						<Box sx={{ width: img1 ? "60%" : "100%" }}>
							{blockTitle && (
								<Box component="h3" sx={estiloH3}>
									{blockTitle}
								</Box>
							)}
							{blockBody && (
								<Box component="p" sx={estiloP}>
									{blockBody}
								</Box>
							)}
						</Box>
						{tipText && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? -60 : -30,
									right: 50,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 270,
									zIndex: 3,
								}}
							>
								{tipText}
							</Box>
						)}
						{sticker2 && (
							<Box
								component="img"
								src={sticker2}
								alt=""
								sx={{
									width: 105,
									position: "absolute",
									bottom: isSmallScreen ? -100 : -60,
									right: -40,
								}}
							/>
						)}
					</Box>

					{comoLlegar && (
						<Box
							data-block-id="text-4"
							sx={{
								backgroundColor: "#fde1e0",
								border: "3px solid",
								borderColor: actualHeaderColor,
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 13,
								color: "#333",
								marginTop: isSmallScreen ? 1 : 1,
								marginBottom: 1.5,
							}}
						>
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: actualHeaderColor,
									textTransform: "uppercase",
								}}
							>
								Cómo llegar
							</Box>
							<Box
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: comoLlegar }}
							/>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template266.thumbnail = "/images/template-1.png";
export default Template266;
